"use client";

import { useState } from "react";
import { useRouter } from "next/navigation";
import { normalizeUsernameParam } from "@/lib/utils";
import { ResumePersonalizationTrigger } from "./ResumePersonalizationTrigger";
import { ResumePersonalizationSheet } from "./ResumePersonalizationSheet";
import { CANDIDATE_PROFILE_ROUTE } from "../personalization.constants";
import {
  readCandidateProfileDraft,
  saveCandidateProfileDraft,
} from "../services/profileDraft";
import type { ResumePersonalizationFlowProps } from "../personalization.types";

export function ResumePersonalizationFlow({
  username,
  controller,
}: ResumePersonalizationFlowProps) {
  const router = useRouter();
  const [open, setOpen] = useState(false);
  const normalizedUsername = normalizeUsernameParam(username);
  const profileRoute = `/@${encodeURIComponent(normalizedUsername)}/${CANDIDATE_PROFILE_ROUTE}`;

  return (
    <>
      <ResumePersonalizationTrigger
        isPersonalized={controller.isPersonalized}
        isSessionLoading={controller.isSessionLoading}
        isUploading={controller.isUploading || controller.isSessionLoading}
        onClick={() => {
          if (
            (controller.isAuthenticated && controller.editableProfile) ||
            readCandidateProfileDraft(normalizedUsername, "jobs_page")
          ) {
            router.push(profileRoute);
          } else setOpen(true);
        }}
      />
      <ResumePersonalizationSheet
        isOpen={open}
        onClose={() => setOpen(false)}
        controller={controller}
        initialStep="upload"
        onParsed={(result) => {
          if (!result.editableProfile) return;
          saveCandidateProfileDraft(normalizedUsername, "jobs_page", {
            externalId: result.externalId,
            ownerExternalId: result.ownerExternalId,
            editableProfile: result.editableProfile,
          });
          setOpen(false);
          router.push(profileRoute);
        }}
        onComplete={() => {
          setOpen(false);
          router.push(profileRoute);
        }}
      />
    </>
  );
}
